<template>
  <div class="graphic-logo-two-content">    
    <div class="description-graphic-logo-two-title-icons-wrapper">
      <div class="graphic-logo-two-icon-wrapper-first">        
        <p class="graphic-logo-two-description1" style="padding-left: 0;">{{ graphicLogoTwoDescription1 }}</p>
      </div>

      <div class="graphic-logo-two-icon-wrapper">
        <p class="e-nao-esqueca">{{ graphicLogoTwoDescription2 }}</p>
        <div class="graphic-logo-icons-warning" >
          <IconCheck />
          <p class="graphic-logo-two-description3" style="width: 378px;">{{ graphicLogoTwoDescription3 }}</p>
        </div>
      </div>
    </div>
    <div class="graphic-logo-two-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicsLogoTwoSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)  

  get graphicLogoTwoDescription1(): string {
    return this.getElementText(5, 1)
  }

  get graphicLogoTwoDescription2(): string {
    return this.getElementText(5, 2)
  }

  get graphicLogoTwoDescription3(): string {
    return this.getElementText(5, 3)
  }

  get ImageSrc(): string {
    return this.getElementMedia(5, 4)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-logo-two-content {
  display: grid;
  max-width: 1032px;
}

.description-graphic-logo-two-title-icons-wrapper {  
  position: relative;  
  display: grid;
  align-items: flex-start;
  grid-template-columns: 51.2% 48.8%;
  margin-top: 3rem;  
}

.graphic-logo-two-description1,
.e-nao-esqueca,
.graphic-logo-two-description3 {
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  
  width: 430px;
}

.graphic-logo-two-description1,
.e-nao-esqueca {
  margin: 0;
}

.graphic-logo-two-description1,
.graphic-logo-two-description3 {
  font-weight: 600;
}

.graphic-logo-two-description3 {
  padding-left: 7px;
}

.graphic-logo-two-icon-wrapper-first {
  display: flex;  
  flex-direction: column;
}

.graphic-logo-two-icon-wrapper {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.graphic-logo-two-card-item {
  position: relative;  
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.graphic-logo-icons-warning{
  display: flex;
  align-items: center;
}
.graphic-logo-container{
  height: 40px;
}
</style>
